import { connect } from 'react-redux'
import  ProductOptions from '../components/product_options'

const mapStateToProps = (state) => {
  return {
    options: state.options
  }
}

const ProductOptionsContainer = connect(mapStateToProps)(ProductOptions);

export default ProductOptionsContainer;



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/app/containers/product_options_container.jsx